jQuery(function ($) {

	$('.wp-video video').each(function() {
		new Plyr(this);
	});

	/**
	 * breakpoints for responsivness
	 * @link https://github.com/jerrylow/breakpoints
	 */

	jQuery(window).breakpoints({
		breakpoints: [{
			"name": "sm",
			"width": 576
		}, {
			"name": "md",
			"width": 768
		}, {
			"name": "lg",
			"width": 992
		}, {
			"name": "xl",
			"width": 1200
		}]
	});

	/**
	 * detects external links and adds target="_blank"
	 */

	var host = window.location.host;

	jQuery('a').not('[href*="' + host + '"]').filter(function () {
		return this.hostname && this.hostname !== location.hostname;
	}).attr('target', '_blank').attr('rel', 'noopener');


	/**
	 * faq
	 */

	$(".js-faq-question").click(function () {
		var $this = $(this);
		$this.toggleClass('active');
		$this.find(".js-faq-icon").toggleClass('rotate');
		$this.siblings(".js-faq-answer").slideToggle("fast");
	});




	/**
	 * cookie consent
	 */

	if (!Cookies.get('consent')) {
		$(".cookie").addClass("active");
	}

	$(".cookie-accept").click(function (e) {
		e.preventDefault();
		$(".cookie").removeClass("active");
		Cookies.set('consent', 'accept', { expires: 365 });
	});



	/**
	* Glossary
		*/

	var $root = $('html, body');
	$('.glossary-nav a').click(function () {
		var scrollHeight = ($( $.attr(this, 'href') ).offset().top - ($(".navigation").height()) - 20 );
		console.log(scrollHeight);
		$root.animate({
			scrollTop: Math.round(scrollHeight)
		},500);

		return false;
	});



	///////////////////////
	///// HIGHLIGHTER /////
	///////////////////////////////////////////////////////////////////////////////////////////////
	var activeSlide = 0;
	var numberOfSlides = $('.highlight__slide').length;


	$(".highlight__arrow__left").click(function (e) {
		e.preventDefault();


		if (activeSlide < 1) {
			activeSlide = numberOfSlides;
		}

		activeSlide = activeSlide - 1;

		$(".highlight__slide").removeClass("next prev prevOut nextOut");
		$(".highlight__slide").eq(activeSlide).addClass("prev");

		if (activeSlide >= numberOfSlides - 1) {
			$(".highlight__slide").eq(0).addClass("prevOut");
		}
		else {
			$(".highlight__slide").eq(activeSlide + 1).addClass("prevOut");
		}

		$(".highlight__nav__point").removeClass("active");
		$(".highlight__nav__point").eq(activeSlide).addClass("active");

	});


	$(".highlight__arrow__right").click(function (e) {
		console.log('highlight__arrow__right click');
		e.preventDefault();

		if (activeSlide == numberOfSlides - 1) {
			activeSlide = -1;
		}

		activeSlide = activeSlide + 1;
		console.log(activeSlide);

		$(".highlight__slide").removeClass("next prev prevOut nextOut");
		$(".highlight__slide").eq(activeSlide).addClass("next");
		$(".highlight__slide").eq(activeSlide - 1).addClass("nextOut");

		$(".highlight__nav__point").removeClass("active");
		$(".highlight__nav__point").eq(activeSlide).addClass("active");




	});


	var activePoint = 1;

	$(".highlight__nav__point").click(function (e) {

		console.log($(this).eq())

		if (activePoint < $(this).eq(activ)) {

		}


		$(".highlight__arrow__right").click()
	});


});




